import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IModel } from "./Remitance";
import { IPermissionProps } from "../../models/Login";
import { IRemitance } from "../../models/Remitance";
import { EmptyRemitance } from "./EmptyRemitance";
import { format } from "date-fns";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRemitance>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);


    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("tbl_Remittance", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IRemitance> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyRemitance });
    };

    const openEdit = (rowDatauser: IRemitance) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };



    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Remittance</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData: IRemitance) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    
    const received_Date = (rowData?: any) => {
        let date;
        if (rowData?.received_Date) date = format(new Date(rowData?.received_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);

    };


    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                value={tableData.tableData}
                emptyMessage="No Branches found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="invoiceNoName" header="Invoice No." sortable />
                <Column field="received_Amount" header="Received Amount" sortable />
                <Column field="deduction" header="Deduction" sortable />
                <Column field="reason" header="Reason" />
                <Column field="received_Date" header="Received Date" body={received_Date} />
                <Column field="followUP" header="Follow Up" />
                <Column field="vendor_InvoiceNo" header="Vendor Invoice No" />

                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}

